// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BweM","rootMobile":"styles_rootMobile__1cviS"};